export default __webpack_public_path__ + "static/media/about-sec-img.c85c7004.png";